import instance from '../utils/api_instance.util';
import { PACK_WRITE_TIMEOUT_MS } from '../utils/packApi.util.js';

export const fetchItemGroupListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/group-list-admin', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const createItemGroupAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/create-group', { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateItemStatusPublish = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/setPublishGroup', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateItemSpecialFlag = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/updateSpecialFlag', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchItemGroupDetails = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/fetchGroupDetailsForAdmin', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateItemGroupAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/update-group', { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
}

export const applyItemGroupDiscount = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/discount/applyItemDiscount', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateItemPositions = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/item/updateItemPositions', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchItemPackPurchaseStatsAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/dashboard/item-purchase-stats', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchItemPackPurchaseHistoryAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/dashboard/item-purchase-history', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};
